import { createFilledIcon } from "../createIcon";

export const LogoutFilledIcon = createFilledIcon(
  <>
    <path d="M10.0073 11.0662L10.0073 5.37499C10.0073 4.89175 10.4 4.5 10.8845 4.5L17.6228 4.5C18.1072 4.5 18.5 4.89175 18.5 5.37499L18.5 18.625C18.5 19.1083 18.1072 19.5 17.6228 19.5H10.8845C10.4 19.5 10.0073 19.1083 10.0073 18.625L10.0073 12.8162H15.4057C15.8902 12.8162 16.2829 12.4245 16.2829 11.9412C16.2829 11.458 15.8902 11.0662 15.4057 11.0662L10.0073 11.0662Z" />
    <path d="M7.50982 11.0662L7.50982 9.31613C7.50982 9.03429 7.18297 8.8776 6.96233 9.05366L3.62647 11.7155C3.45784 11.8501 3.45784 12.1059 3.62647 12.2404L6.96233 14.9023C7.18297 15.0784 7.50982 14.9217 7.50982 14.6398L7.50982 12.8162H10.0137V11.0662L7.50982 11.0662Z" />
  </>,
  "LogoutFilledIcon"
);
